import React, { useContext, useEffect, useRef, useState } from "react";
import SidebarList from "./SidebarList";
import DocumentView from "./DocumentView";
import { resetReadOnlyDoc, getDocumentsById, appendDocumentsById, getFile, getElasticSearchDocuments, prevFileData, findDocumentsById, updateSelectedFileWithUpdatedSocketId, updateSocketId, getDocumentTypeRules } from "../../context/actions/document";
import { useDispatch, useSelector } from "react-redux";
import { pagination, documentFilterItems } from '../../utils/constants';
import '../../assets/css/common/document/index.scss';
import { SocketContext } from '../../context/actions/socket';
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
//import jsonData from './data.json';
import { toast } from "react-toastify";
import DocAssistWindowManager from "./DocAssistWindowManager"; // Import the window manager
var _ = require('lodash');
let docAssistWindow;

DocAssistWindowManager.init();


const DocumentDetail = () => {
	const [openedWindow, setOpenedWindow] = useState([]);
	const location = useLocation();
	let valiadationData = useSelector((state) => state?.document?.validationJson);
	const [filterSelected, setFilterSelected] = useState();
	const [sortBySelected, setSortBySelected] = useState();
	const navigationState = useSelector((state) => state.navigationReducer.isOn);
	let totalDocRecords = useSelector((state) => state.document.totalDocRecords);
	const dispatch = useDispatch();
	const actPage = useSelector(state => state.general.page !== "" ? state.general.page : pagination.page)
	const [sidebarLoading, setSidebarLoading] = useState(false);
	const [sidebarLoadingLabel, setSidebarLoadingLabel] = useState('View More');
	const [sidbarLoadingButton, setSidbarLoadingButton] = useState(false);
	// const [page, setPage] = useState(actPage);
	const [page, setPage] = useState(location?.state?.page);
	const [paginations] = useState(10);
	const [loader, setLoader] = useState(false);
	const [showTab, setShowTab] = useState(false);
	const folder = useSelector((state) => state?.document?.folder || null);
	const files = useSelector((state) => state?.document?.docRecords)
	const [innerLoader, setInnerLoader] = useState(false);
	const selectedFile = useSelector((state) => state.document.fileData);
	const selectedFileId = useSelector((state) => state.document.selectedFileId);
	const myAssigned = useSelector((state)=> state?.document?.myAssigned)
	console.log('selected file id ->', selectedFileId)

	useEffect(()=> {
		console.log("asasdasdasdlist",files)
	}, [files])
	//const selectedFile = jsonData;

	const sellerLoanNumberOnPage = useSelector((state) => state.document?.fileData?.multi_loan_identifier?.page);
	const is_multi_loan = useSelector((state) => state.document?.fileData?.is_multi_loan);
	const [reviewRequested, setReviewRequested] = useState(false)
	const [otherDocuments, setOtherDocuments] = useState(false)
	const [title, setTitle] = useState(location?.state?.title ? location?.state?.title : "")
	const [documentList, setDocumentList] = useState();

	let [payload, setPayload] = useState({ folder: folder, limit: paginations, page: page, deleted: false });
	const [deleted, setDeleted] = useState(location?.state?.deleted ? location?.state?.deleted : false)
	let [elasticPayload, setElasticPayload] = useState({ folder: folder });
	const [elasticSearchList, setElasticSearchList] = useState([]);
	let [focusSearchFlag, setFocusSearchFlag] = useState(false);

	const activeId = useSelector((state) => state.document.activeId);
	const [prevFileId, setPrevFileId] = useState(null);
	const [sortFn, setSortFn] = useState(0);
	const [selectedId, setSelectedId] = useState(null);
	const [type, setType] = useState(location?.state?.type ? location?.state?.type : "")
	const [checkValiadation, setCheckValiadation] = useState({});
	const [isOnline, setIsOnline] = useState(navigator.onLine);
	const currentDocument = useSelector((state) => state.document.fileData);
	const userDetail = useSelector((state) => state?.user?.user);
	const { backendSocket } = useContext(SocketContext);
	let docRecords = useSelector((state) => state.document.docRecords);
	const docAssistWindowRef = useRef(null);
	const MySwal = withReactContent(Swal)

	//const nextPage = useSelector((state) => state.document.hasNextPage);
	
	const [hasPrevPage, setHasPrevPage] = useState(location?.state?.hasPrevPage)
	const [hasNextPage, setHasNextPage] = useState(location?.state?.hasNextPage)
	
	const [filterType, setFilterType] = useState(location?.state?.filterType ? location?.state?.filterType: false)
	const [packetType, setPacketType] = useState(location?.state?.packetType ? location?.state?.packetType: false)

	const [cTextChanges, setCTextChanges] = useState([]);
	const [cTagsChanges, setCTagsChanges] = useState([]);
	const [cCheckChanges, setCCheckChanges] = useState([]);

	const [vTextChanges, setVTextChanges] = useState([]);
	const [vTagsChanges, setVTagsChanges] = useState([]);
	const [vCheckChanges, setVCheckChanges] = useState([]);
	const [selectDocPacketId, setSelectedDocPacketId] = useState("");

	// Check the changes in C tag
	const checkCTagChanges = (cText, cTags, cCheck) => {
		// setCTextChanges(cText)
		// setCTagsChanges(cTags)
		// setCCheckChanges(cCheck)
	}

	// Check the changes in V tag
	const checkVTagChanges = (vText, vTags, vCheck) => {
		// setVTextChanges(vText)
		// setVTagsChanges(vTags)
		// setVCheckChanges(vCheck)
	}
	
	// console.log('getting refreshed ... docDetail', backendSocket.id)
	useEffect(() => {
		// window.addEventListener("popstate", (event) => {
		// 	if(event.state){
		// 		if(currentDocument.reading_by === userDetail?._id){
		// 			// alert("back button")
		// 			dispatch(resetReadOnlyDoc({ docId: currentDocument._id}, (result) => {
		// 				if(result){
		// 					backendSocket.emit('check-doc-status', currentDocument) 
		// 					console.log(currentDocument._id," doc reset")
		// 				}
		// 			}))
		// 		} 
		// 	}
		//   });

		const handleOnline = () => {
			setIsOnline(true);
		};

		const handleOffline = () => {
			// if(currentDocument?.reading_by === userDetail?._id){
			// 	dispatch(resetReadOnlyDoc({ docId: currentDocument._id}, (result) => {}))
			// 	backendSocket.emit('check-doc-status', currentDocument) 
			// 	setIsOnline(false);
			// }
		};

		const handleBeforeUnload = (event) => {
			// 	event.preventDefault();
			//   event.returnValue = ''; // Display a confirmation message if needed
			// if(currentDocument?.reading_by === userDetail?._id){
			// 	dispatch(resetReadOnlyDoc({ docId: currentDocument._id}, (result) => {
			// 		if(result){
			// 			backendSocket.emit('check-doc-status', currentDocument)
			// 			console.log(currentDocument._id," doc reset")
			// 		}
			// 	}))
			// } 
		};

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);
		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [userDetail, currentDocument, dispatch]);

	useEffect(() => {
		if (!currentDocument || Object.keys(currentDocument).length === 0) return;
	
		const documentTypeId = currentDocument?.packet_type?._id;
		const organizationId = currentDocument?.organization;
		
		// Calculate dimensions and position for the window
		const width = window.innerWidth * 0.5;
		const height = window.innerHeight * 0.8;
		const gap = 20;
		const left = window.innerWidth - width - gap;
		const top = window.innerHeight - height + 2 * gap;
	  
		// Construct URL for the docAssistRules page
		const docAssistUrl = `/docAssistRules?packetId=${documentTypeId}&orgId=${organizationId}`;
	  
		// Use the window manager to open or update the docAssist window
		DocAssistWindowManager.openOrUpdateDocAssistWindow(docAssistUrl, width, height, left, top);
		
	  }, [currentDocument]);
	  

	// const validationDataa = valiadationData?.processedDocument?.results
	if (valiadationData?.processedDocument?.results) {
		valiadationData.processedDocument.results.map((data) => {
			if (!data?.sortOrder) {
				data.sortOrder = 0;
			}
			return data

		})
		valiadationData.processedDocument.results = _.orderBy(valiadationData.processedDocument.results, 'sortOrder', 'desc')
	}

	// useEffect(()=>{
	// 	setHasPrevPage(documentList?.hasPrevPage)
	// 	setHasNextPage(documentList?.hasNextPage)
	// }, [documentList])

	const validationDataStatic = valiadationData?.processedDocument?.results && valiadationData.processedDocument.results.map((item) => {
		if (item?.processingResult?.errors) {
			const error = item.processingResult.errors;
			if (error.length > 1) {
				return error.map((error1) => {
					return error1?.accepted || false;
				})
			}
			else if (error.length === 1) {
				return error[0]?.accepted || false;
			}
		}
		return false;
	});   // code tested on codepen , working fine

	const validationErrorStatic = valiadationData?.processedDocument?.errors && valiadationData.processedDocument.errors.map((item) => {
		if (item.accepted) {
			return true;
		} else {
			return false;
		}
	});


	// const [textChange, setTextChange] = useState([]);
	const filterSelectedFn = (val) => {
		setFilterSelected(val)
	}
	const sortBySelectedFn = (val) => {
		setSortBySelected(val)
	}


	useEffect(() => {


		if (selectedFileId) {
			_handleSelected(selectedFileId, activeId) // April2023 check if needed  
		}
	}, []);

	useEffect(() => {

		if (selectedFileId) {
			console.log('running jkhasdkjhasdjhasjdhasj')
			updateSocketIdFncn(selectedFileId) // April2023 check if needed  
		}

	}, [backendSocket.id]);

	// useEffect(() => {

	// },[selectedId])


	const _advanceFilter = async (val) => {
		setSortFn(0)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setInnerLoader(true);
		let advFilter = documentFilterItems[val]
		payload = { ...payload, ...advFilter, myAssigned: myAssigned };
		setPage(1);
		// payload = { ...payload, ...advFilter, reviewRequested: reviewRequested, otherDocuments: otherDocuments, type: location?.state?.type ? location?.state?.type : type }
		elasticPayload = { ...payload, ...advFilter, myAssigned: myAssigned, page: 1 }
		setElasticSearchList([]);
		setElasticPayload(elasticPayload);
		setPayload(payload);
		if (val.trim()) {
			// elasticPayload = { ...elasticPayload, name: val }
			// setElasticPayload(elasticPayload)
			// await dispatch(getElasticSearchDocuments(elasticPayload, ((result) => {
			// 	setInnerLoader(false);
			// 	setElasticSearchList(result?.hits?.hits);
			// 	setFocusSearchFlag(true);
			// })));
		}
		payload = {
			...payload, ...advFilter,parentName: location?.state?.title ? location?.state?.title : title, page: 1, reviewRequested: reviewRequested, otherDocuments: otherDocuments, deleted: deleted, myAssigned: myAssigned
			// docId: location?.state?.documentExclude
			// type: reviewRequested || otherDocuments ? "" : location?.state?.type ? location?.state?.type : type 
		}
		dispatch(findDocumentsById(payload, ((result) => {
			// dispatch(getDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				//	setList(result.docs)
				_handleSelected(result.docs[0]._id)
				setHasPrevPage(result?.hasPrevPage); // Set the flag for previous page
				setHasNextPage(result?.hasNextPage); // Set the flag for next page
			}
			setSidebarLoading(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));
	}


	/**
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */

	const reviewRequestedValue = (reviewRequested) => {
		setReviewRequested(reviewRequested)
	}

	const otherDocumentsValue = (otherDocuments) => {
		setOtherDocuments(otherDocuments)
	}

	const __advanceFilter = async (sortBy, order) => {
		setSortFn(1)
		setInnerLoader(true);
		payload = { ...payload,parentName: location?.state?.title ? location?.state?.title : title, sort: sortBy, order: order, page: 1, reviewRequested: reviewRequested, otherDocuments: otherDocuments, type: location?.state?.type ? location?.state?.type : type, deleted: deleted, myAssigned: myAssigned }
		setPayload(payload);
		setPage(1);
		dispatch(findDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				//setList(result.docs)
				_handleSelected(result.docs[0]._id)
				setHasPrevPage(result?.hasPrevPage); // Set the flag for previous page
				setHasNextPage(result?.hasNextPage); // Set the flag for next page

			}
			setSidebarLoading(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));

	}


	const _resetFilter = () => {
		setInnerLoader(true);
		setPage(1);
		payload = { parentName: location?.state?.title ? location?.state?.title : title, folder: folder, deleted: deleted, limit: paginations, page: 1, reviewRequested: reviewRequested, otherDocuments: otherDocuments, type: reviewRequested || otherDocuments ? "" : type, myAssigned: myAssigned }
		setPayload(payload);
		setFocusSearchFlag(false);
		setElasticSearchList([]);
		let elasticPay = { parentName: location?.state?.title ? location?.state?.title : title, folder: folder, reviewRequested: reviewRequested, otherDocuments: otherDocuments, type: type, myAssigned: myAssigned }
		setElasticPayload(elasticPay);
		dispatch(findDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				_handleSelected(result.docs[0]._id)
				setSelectedId(result?.docs[0]?._id);
				setHasPrevPage(result?.hasPrevPage); // Set the flag for previous page
				setHasNextPage(result?.hasNextPage); // Set the flag for next page
			}
			setSidebarLoading(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));
	}


	// Save C Tag Data before page change
	const saveCData = () => {
		console.log("Saving C Data")
	}

	// Save V Tag Data before page change
	const saveVData = () => {
		console.log("Saving V Data")
	}

	const _handlePageChange = (activePage, reviewRequested, otherDocuments) => {
		setPage(activePage);
		setReviewRequested(reviewRequested)
		setOtherDocuments(otherDocuments)
		setSidebarLoading(true);
		setSidebarLoadingLabel('loading');
	payload = { ...payload, parentName: location?.state?.title ? location?.state?.title : title, page: activePage, reviewRequested: reviewRequested, otherDocuments: otherDocuments, docId: location?.state?.documentExclude, type: reviewRequested || otherDocuments ? "" : location?.state?.type ? location?.state?.type : type, deleted: deleted, myAssigned: myAssigned/*, packetType :filterType? packetType : ""*/ }

		if (cTextChanges.length == 0 && cTagsChanges.length == 0 && cCheckChanges.length == 0 && vCheckChanges.length == 0 && vTagsChanges.length == 0 && vTextChanges.length == 0) {
			dispatch(appendDocumentsById(payload, ((result) => {
				if(filterType){
					result.docs = Array.from(new Set(result.docs.map(a => a._id)))
						.map(_id => {
							return result.docs.find(a => a._id === _id);
						});
				}
				setDocumentList(result)
				_handleSelected(result?.docs[0]?._id)
				setSelectedId(result?.docs[0]?._id);
				setHasPrevPage(result?.hasPrevPage)
				setHasNextPage(result?.hasNextPage)
				setSidebarLoading(false);
				setSidebarLoadingLabel('View More');
			})));
		} else if (cTextChanges.length != 0 || cTagsChanges.length != 0 || cCheckChanges.length != 0) {
			MySwal.fire({
				title: 'Are you sure?',
				text: "You have unsaved changes, Do you want to change the page",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, change it!',
				showCloseButton: true
			}).then((result) => {
				if (result.isConfirmed) {
					dispatch(appendDocumentsById(payload, ((result) => {
						setDocumentList(result)
						_handleSelected(result?.docs[0]?._id)
						setSelectedId(result?.docs[0]?._id);
						setHasNextPage(result?.hasNextPage)
						setHasPrevPage(result?.hasPrevPage)
						setSidebarLoading(false);
						setSidebarLoadingLabel('View More');
						dispatch(getDocumentTypeRules({organization: result?.docs[0].organization, docType: result?.docs[0].packet_type._id},()=> {}))
					})));
				}
			})
		}
		else if (vCheckChanges.length != 0 || vTagsChanges.length != 0 || vTextChanges.length != 0) {
			MySwal.fire({
				title: 'Are you sure?',
				text: "You have unsaved changes, Do you want to save the changes?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, change it!',
				showCloseButton: true
			}).then((result) => {
				if (result.isConfirmed) {
					dispatch(appendDocumentsById(payload, ((result) => {
						setDocumentList(result)
						_handleSelected(result?.docs[0]?._id)
						setSelectedId(result?.docs[0]?._id);
						dispatch(getDocumentTypeRules({organization: result?.docs[0].organization, docType: result?.docs[0].packet_type._id},()=> {}))
						setHasNextPage(result?.hasNextPage)
						setHasPrevPage(result?.hasPrevPage)
						setSidebarLoading(false);
						setSidebarLoadingLabel('View More');
					})));
				}
			})
		}
		// delete payload.packetType
	}
	const handleTabChange = () => {
		setShowTab(!showTab)
	}

	/**
	* @description funnction call to search value by elasticsearc
	* @param {string} param search value
	 */

	const _elasticSearch = async (val) => {
		if (val.trim()) {

			elasticPayload = { ...elasticPayload, parentName: location?.state?.title ? location?.state?.title : title, name: val, reviewRequested: reviewRequested, otherDocuments: otherDocuments, type: location?.state?.type ? location?.state?.type : type, myAssigned: myAssigned }
			setElasticPayload(elasticPayload)
			await dispatch(getElasticSearchDocuments(elasticPayload, ((result) => {

				setInnerLoader(false);
				setElasticSearchList(result?.hits?.hits);
				setFocusSearchFlag(true);
			})));
		} else {
			setElasticSearchList([])
		}

	};

	const _docSearch = async (val) => {
		setPage(1);
		setInnerLoader(true);
		
		payload = {
			...payload,parentName: location?.state?.title ? location?.state?.title : title, fields: "name", filter: val, page: 1, reviewRequested: reviewRequested, otherDocuments: otherDocuments, myAssigned: myAssigned,
			type: location?.state?.type ? location?.state?.type : type 
		}
		console.log(payload, "payload of Docsearch")
		setPayload(payload);
		dispatch(findDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {

				_handleSelected(result.docs[0]._id)
			}
			setSidebarLoading(false);
			setLoader(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));

	};


	//    useEffect(()=>{
	//     backendSocket.on("unlock-document-Id",(unlockDocDetails)=>{
	// 	if(unlockDocDetails._id  && unlockDocDetails?.read_only === true && unlockDocDetails?.reading_by !== userDetail._id)
	// 	{ 
	//         readOnlyBroadcastMessage()
	// 	    // toast.success('This file has been unlocked by adminstrator. Please refresh the page to start editing!');
	// 	}
	//     })
	//   },[])	

	const _handleSelected = async (id) => {

		// if(openedWindow && openedWindow?.length > 0){
		// 	for(let i = 0; i < openedWindow?.length; i++ ){
		// 		openedWindow[i].close()
		// 	}
		// 	dispatch({type: "OPENED_TAB", data: []})
		// }
		setLoader(true);
		setShowTab(true);
		setSelectedId(id);
		const previousValue = selectedFileId
		setPrevFileId(previousValue);
		// if(id !== selectedFile._id && selectedFile.read_only !== true){
		// if(id !== selectedFile._id && selectedFile.read_only){
		// 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// 		if(result){
		// 			// console.log(selectedFile._id," doc reset")
		// 		}
		// 	}))
		// }
		dispatch({ type: "RESET_DATA", data: [] }); // reset data
		// let data = { docId: id, Au: null, socketId: window.socket.id }
		let data = { docId: id, Au: null, socketId: backendSocket.id }
		if (is_multi_loan) {
			data.pageNumber = sellerLoanNumberOnPage;
		}
		let version = localStorage.getItem('version')
		localStorage.removeItem('version')
		if (version)  // to hit file with particular version if we come through autosave file listing modal
			data.version = version

		// const reload = () => {
		console.log('very unique id content -->', document.getElementById('veryUniqueId'));
		if (document.getElementById('veryUniqueId') !== null) {
			document.getElementById('veryUniqueId').value = id;
		}
		console.log('very unique id content -->', document.getElementById('veryUniqueId'));
		// }
		// setTimeout(reload, 2000);
		// revert comment


		dispatch(getFile(data, (response) => {
			if (response) {
				if (response?.revisionsId && response?.revisionsId?.length > 0) {
					const index = docRecords.findIndex(obj => obj._id === data.docId);
					data.docId = response?.revisionsId[response?.revisionsId?.length - 1]?._id;
					dispatch(getFile(data, (response) => {
						if (response) {
							if (index !== -1) {
								docRecords[index] = response;
								console.log(docRecords, "totalDocsRecords")
								dispatch({ type: "LIST_DOCUMENT", data: docRecords, totalDocRecords: totalDocRecords });
							}
							setCheckValiadation(response.validationJson)
							setLoader(false)
							setSelectedId(response._id)
						}
					}))
				}else{
					setCheckValiadation(response.validationJson)
					setLoader(false)
					setSelectedId(response._id)

				}
				localStorage.setItem('loggedInOrg', `${userDetail?._id}`)
				dispatch(getDocumentTypeRules({organization: response.organization, docType: response.packet_type._id},()=> {}))
				//    if(response?.read_only === true)
				//    {  
				// 	  setTimeout(() => {
				// 	  toast.success("You are viewing the document in ready only mode.")
				//       },3000);
				//    }
			}
		})
		);


	};

	const updateSocketIdFncn = async (id) => {
		// setLoader(true);
		// setShowTab(true);
		// setSelectedId(id);
		// const previousValue = selectedFileId
		// setPrevFileId(previousValue);
		// // if(id !== selectedFile._id && selectedFile.read_only !== true){
		// // if(id !== selectedFile._id && selectedFile.read_only){
		// // 	dispatch(resetReadOnlyDoc({ docId: selectedFile._id}, (result) => {
		// // 		if(result){
		// // 			// console.log(selectedFile._id," doc reset")
		// // 		}
		// // 	}))
		// // }
		// dispatch({ type: "RESET_DATA", data: [] }); // reset data
		// // let data = { docId: id, Au: null, socketId: window.socket.id }
		let data = { docId: id, Au: null, socketId: backendSocket.id }

		// // const reload = () => {
		console.log('very unique id content -->', document.getElementById('veryUniqueId'));
		if (document.getElementById('veryUniqueId') !== null) {
			document.getElementById('veryUniqueId').value = id;
		}
		console.log('very unique id content -->', document.getElementById('veryUniqueId'));
		// }

		dispatch(
			updateSocketId(data, (res) => {
				console.log('update socket result working ...')
			})
		)

	};

	useEffect(() => {
		if (totalDocRecords && totalDocRecords > paginations * page) {
			setSidbarLoadingButton(true)
		} else {
			setSidbarLoadingButton(false)
		}
	});
	const focusSearch = (val) => {
		setFocusSearchFlag(val);
	}
	useEffect(() => {
		const handleWindowClick = () => {
			setFocusSearchFlag(false)
		}
		if (focusSearchFlag) {
			window.addEventListener('click', handleWindowClick);
		}
	}, [focusSearchFlag]);

	useEffect(() => {
		if (selectedFile?._id !== undefined) {
			viewFile()
			// console.log('socket id update function running -->')
			// socketIdUpdate()

		}
	}, [selectedFile?._id])

	

	const viewFile = () => {
		//store in hidden field 
		// document.getElementById('veryUniqueId').value = selectedFileId

		backendSocket.off('UpdateViewMore').on('UpdateViewMore', (res, err) => {
			if (res) {
				console.log('very unique view file data res 123 ->', res?.data, document.getElementById('veryUniqueId'))
				if (res && res?.data?.docId === document.getElementById('veryUniqueId')?.value) {  // js get element 
					if (res?.data?.count && res?.data?.count != 0)
						dispatch({ type: "SET_VIEW_RECORD", data: true })
					else
						dispatch({ type: "SET_VIEW_RECORD", data: false })
				}
				// else {
				// 	dispatch({ type: "SET_VIEW_RECORD", data: false })
				// }
			}
		})


		// socket.on(`view-${selectedFile._id}`, (res, err) => {

		// 	if (res) {
		// 		if (res?.data?.count && res?.data?.count != 0)
		// 			dispatch({ type: "SET_VIEW_RECORD", data: true })
		// 		else
		// 			dispatch({ type: "SET_VIEW_RECORD", data: false })
		// 	}
		// 	else {
		// 	}
		// })

		// socket conditions failing in conditions when two user selects a same file from side bar view value in reducer
		// is not being updated. 
		// socket.on('UpdateViewMore', (res) => {
		// 	if (res) {
		// 		if (res?.data?.conew selectedfileid =>unt && res?.data?.count != 0)
		// 			dispatch({ type: "SET_VIEW_RECORD", data: true })
		// 		else
		// 			dispatch({ type: "SET_VIEW_RECORD", data: false })
		// 	}
		// 	else {
		// )
		// 		dispatch({ type: "SET_VIEW_RECORD", data: false })
		// 	}
		// })
	}
	// const socketIdUpdate = () => {
	// 	backendSocket.off(`updatesocket`).on(`updatesocket`, (res) => {
	// 		if (res) {
	// 			console.log('res of updateSocket event -->', res)
	// 			let data = { docId: selectedFile._id, socketId: res.data }

	// 			dispatch(updateSelectedFileWithUpdatedSocketId(data, (response) => {
	// 				if (response) {
	// 					// setLoader(false)
	// 				}
	// 			})
	// 			);

	// 		}
	// 	})
	// }



	// useEffect(() => {
	// 	if (selectedFile?._id !== undefined) {
	// 		_handleSelected(selectedFile?._id)
	// 		// socketIdUpdate()
	// 	}
	// }, [selectedFile._id])




	return (
		<>
			<div className="documents-wrapper tab-layout d-flex flex-fill overflow-auto position-relative">
				<div className=
					{`left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? 'active' : ''}
				`}>
					{files &&
						<SidebarList
							hasNextPage={hasNextPage}
							hasPrevPage={hasPrevPage}
							title={location?.state?.title ? location?.state?.title : title}
							filterSelected={filterSelected}
							sortBySelected={sortBySelected}
							filterSelectedFn={(val) => filterSelectedFn(val)}
							sortBySelectedFn={(val) => sortBySelectedFn(val)}
							sortFn={sortFn} sidebarLoading={sidebarLoading} sidebarLoadingLabel={sidebarLoadingLabel}
							_filter={_advanceFilter}
							_loader={loader}
							__filter={(sortBy, order) => __advanceFilter(sortBy, order)}
							_resetFilter={_resetFilter}
							sidbarLoadingButton={sidbarLoadingButton} page={page} handlePageChange={(page, reviewRequested, otherDocuments) => _handlePageChange(page, reviewRequested, otherDocuments)} list={files} handleSelectedAction={(id) => _handleSelected(id)} search={(val) => _docSearch(val)} _innerLodder={innerLoader} handleElasticSearch={(val) => _elasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} _focusSearch={(val) => focusSearch(val)} totalDocRecords={totalDocRecords} reviewRequestedValue={reviewRequestedValue} otherDocumentsValue={otherDocumentsValue} />
					}
				</div>
				<div className="mid-col d-flex flex-column flex-fill overflow-auto position-relative">
					<div className="inner-blc d-flex flex-column flex-fill overflow-auto">

						{!loader && files.length ? (
							<DocumentView
								select_Folder_id={location?.state?.selectFolder_id}
								sidebarActivePacketIndex={location?.state?.sidebarActivePacketIndex}
								filterSelectedFn={(val) => filterSelectedFn(val)}
								sortBySelectedFn={(val) => sortBySelectedFn(val)}
								deletedDisable={deleted}
								checkCTagChanges={checkCTagChanges}
								checkVTagChanges={checkVTagChanges}
								saveCData={saveCData}
								saveVData={saveVData}
								openedWindow={openedWindow}
								setOpenedWindow = {setOpenedWindow}
								payload={payload} _handleTabChange={handleTabChange} 
								files={files} 
								_handleSelected={_handleSelected} 
								_checkValiadation={checkValiadation} 
								_setCheckValiadation={setCheckValiadation} 
								_validationDataStatic={validationDataStatic} 
								_validationErrorStatic={validationErrorStatic} />

						) : (null)}


					</div>
				</div>
			</div>
		</>
	)
};
export default DocumentDetail;